import styled from 'styled-components';

const InputLabel = styled.label`
  font-size: 12px;
  text-align: left;
  color: rgba(0, 0, 0, 0.4);
`;

export default InputLabel;
